document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('cotizacion-form');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    var btn = document.getElementById('cotizacion-btn');
    btn.disabled = true;
    btn.textContent = 'Enviando...';

    var data = {
      nombre: document.getElementById('cot-nombre').value,
      apellido: document.getElementById('cot-apellido').value,
      email: document.getElementById('cot-email').value,
      telefono: document.getElementById('cot-telefono').value,
      calle: document.getElementById('cot-calle').value,
      detalle: document.getElementById('cot-detalle') ? document.getElementById('cot-detalle').value : '',
      comuna: document.getElementById('cot-comuna').value,
      region: document.getElementById('cot-region').value,
      body: document.getElementById('cot-productos') ? document.getElementById('cot-productos').value : '',
      quantity: document.getElementById('cot-quantity') ? document.getElementById('cot-quantity').value : 0,
      total_weight_kg: document.getElementById('cot-weight') ? document.getElementById('cot-weight').value : 0,
      items: [],
    };


    console.log('Enviando datos:', JSON.stringify(data));

    try {
      var res = await fetch('https://api.ustucco.cl/apps/cotizacion-flete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      console.log('Status:', res.status);
      var json = await res.json();
      console.log('Respuesta:', JSON.stringify(json));
      if (json.success) {
        window.location.href = '/pages/cotizacion-enviada';
      } else {
        alert('Error: ' + json.error);
        btn.disabled = false;
        btn.textContent = 'Solicitar cotización de flete';
      }
    } catch (err) {
      console.log('Error:', err.message);
      alert('Error de conexión: ' + err.message);
      btn.disabled = false;
      btn.textContent = 'Solicitar cotización de flete';
    }
  });
});
